import React from "react";
import styled from "styled-components";
import { Grid } from "react-loader-spinner";

const LoaderContainer = styled.div<LoaderContainerParams>`
    position: absolute;
    background: ${({ background }) => background || "white"};
    z-index: 3;
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
`;

interface LoaderContainerParams {
    background: string | undefined;
}

export const AppLoader = ({
    color,
    height,
    width,
    background = undefined,
}: {
    color: string;
    height: string | number;
    width: string | number;
    background?: string;
}) => {
    return (
        <LoaderContainer background={background}>
            <Grid color={color} height={height} width={width} />
        </LoaderContainer>
    );
};
